import { Controller } from "@hotwired/stimulus"

// This controller is used to set the verification status of a lead to pending (showing a spinner).
export default class extends Controller {
  static get targets() {
    return ["loader", "emailInput"]
  }

  //
  enrich() {
    const emailInputValue = this.emailInputTarget.value
    const form = this.element

    if (App.validateEmail(emailInputValue)) {
      this.loaderTarget.classList.remove("d-none")

      fetch(`/leads/enrich?email=${emailInputValue}`, {
        credentials: "same-origin",
        method: "POST",
        headers: this._headers(),
      })
      .then(response => response.json())
      .then(response => {
        Object.keys(response).forEach(element => {
          const input = form.querySelector(`[name="lead[${element}]"]`)

          if (response[element] && input.value.length === 0) {
            input.value = response[element]
          }
        })

        this.loaderTarget.classList.add("d-none")
      })
    }
  }

  _headers() {
    let headers = {
      "Accept": "application/json",
      "Content-Type": "application/json",
    }

    if (document.querySelector("meta[name='csrf-token']")) {
      headers["X-CSRF-Token"] = document.querySelector("meta[name='csrf-token']").content
    }

    return headers
  }
}
